module.exports = __webpack_public_path__ + "img/update.acfb3f9d.png";